// src/components/navigation/TopAppBar.js
import React from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Avatar,
  Button,
  Box,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { getAuth } from "firebase/auth";
import useStore from "../../store/useStore";

const routeTitleMap = {
  "/home": "nFlight",
  "/watch": "Watch",
  "/series": "Series",
  "/messages": "Time Capsules",
  "/messages/drop": "Drop Time Capsule",
  "/profile/settings": "Settings",
  "/timecapsule": "Time Capsule",
  "/pin": "Explore Details",
  "/": "nFlight",
};

const TopAppBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const auth = getAuth();
  const user = auth.currentUser;

  // Get the user profile from the global store
  const { userProfile } = useStore();

  // Determine the title based on the current route
  const path = location.pathname;
  let title = "";
  for (const route in routeTitleMap) {
    if (path.startsWith(route)) {
      title = routeTitleMap[route];
      break;
    }
  }
  if (!title) {
    title = path.replace("/", "").toUpperCase() || "App";
  }

  // Show back button if not on home
  const showBackButton = path !== "/" && path !== "/";

  // Use the profile image from the global store; fallback to firebase's photoURL if needed
  const avatarSrc =
    (userProfile && userProfile.profileImage) || (user && user.photoURL) || "";

  return (
    <AppBar
      position="fixed"
      color="primary"
      sx={{
        boxShadow: "none",
        height: "70px",
        display: "flex",
        justifyContent: "flex-end",
        paddingBottom: "15px",
      }}
    >
      <Toolbar
        sx={{
          width: "100%",
          alignItems: "flex-end",
          minHeight: "unset",
        }}
      >
        {showBackButton ? (
          <IconButton edge="start" color="inherit" onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </IconButton>
        ) : (
          <Box sx={{ width: 48 }} />
        )}
        <Typography
          variant="h6"
          sx={{
            flexGrow: 1,
            textAlign: "center",
            paddingBottom: "5px",
          }}
        >
          {title}
        </Typography>
        {user ? (
          <Link
            to="/profile/settings"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <Avatar alt="User Avatar" src={avatarSrc}>
              {user.displayName ? user.displayName[0].toUpperCase() : ""}
            </Avatar>
          </Link>
        ) : (
          <Box>
            <Button
              color="inherit"
              component={Link}
              to="/signin"
              sx={{ textTransform: "none" }}
            >
              Sign In
            </Button>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default TopAppBar;
